import React, { Component } from 'react';

import tooltipIcon from '../../../images/icons/info.svg';

class HeroTooltip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTooltip: false,
    };
  }

  toggleTooltip() {
    this.setState({ showTooltip: !this.state.showTooltip });
  }

  render() {
    const { showTooltip } = this.state;
    const { tooltipType } = this.props; // Earnings or Revenue

    const text =
      `Overall ${tooltipType} may include Rakuten or other affiliate ${tooltipType.toLowerCase()}` +
      ` that ${
        tooltipType === 'Revenue' ? 'is' : 'are'
      } generated outside of the Narrativ network.`;

    return (
      <div className={`hero-tooltip ${tooltipType.toLowerCase()}`}>
        <img
          src={tooltipIcon}
          onMouseEnter={() => this.toggleTooltip()}
          onMouseLeave={() => this.toggleTooltip()}
          alt={`${tooltipType} tooltip icon`}
          className="tooltip-info"
        />
        <div className={`tooltip-text${showTooltip ? ' show' : ''}`}>
          <h2 className="title">{tooltipType}</h2>
          <p className="text">{text}</p>
        </div>
      </div>
    );
  }
}

export default HeroTooltip;
